module.exports = __webpack_public_path__ + "static/media/other3.c8796dba.jpg";